// You are here: src/components/Chrome/index.js
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import withRoot from '../../themes/withRoot';
import Sidebar from '../Sidebar';
import Footer from '../Footer';

const Container = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    display: flex;
    flex-direction: column;
    height: 100%;
    color: #333;
    background: white;
    line-height: 1.2;
    letter-spacing: 0.5px;
`;
const Content = styled.div`
    display: flex;
    min-height: 100vh;
    width: 100vw;
    overflow: scroll;
    letter-spacing: 0.5px;
    a {
        &:hover {
            filter: brightness(80%);
        }
    }
`;
const Main = styled.div`
    display: flex;
    flex: 1 1 auto;
    background: white;
    letter-spacing: 0.5px;
    max-width: 100vw;
    h1 {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 26px;
        letter-spacing: 0.5px;
    }
    h2 {
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 18px;
        letter-spacing: 0.5px;
    }
    h3 {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 14px;
        letter-spacing: 0.5px;
    }
    p {
        margin-bottom: 8px;
        letter-spacing: 0.5px;
    }
`;
const Page = styled.div`
    padding-top: 60px;
    flex: 1;
    letter-spacing: 0.5px;
    max-width: 100vw;
`;
const Chrome = ({ children, header }) => (
    <Container>
        {header}
        <Content>
            <Sidebar />
            <Main>
                <Page>{children}</Page>
            </Main>
        </Content>
        <>
            <Footer />
        </>
    </Container>
);

Chrome.propTypes = {
    children: PropTypes.node,
    header: PropTypes.node,
};
export default withRoot(Chrome);
